export const CITYS = "citys";
